export default __webpack_public_path__ + "static/media/icon_automatic-install.249add49.svg";